import * as angular from 'angular';
import {IController} from "angular";

export class ServiceRelationTaskItemCtrl implements IController {
  index: any;
  relation: any;
  canRemove: boolean;
  canUnlink: boolean;
  activateActionsOnHover: boolean;
  taskRelatingToType: any;
  onRemove: Function;
  onUnlinkRelatedTask: Function;

  private relationAccount: any;
  private relationAgent: any;
  public isShowActions: boolean = false;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    this.relationAccount = {};
    this.relationAgent = {};

    if (this.relation) {
      this.relationAccount = {
        id: this.relation.details.accountId,
        name: this.relation.details.accountName
      };
      this.relationAgent = this.relation.details.agentId ? {
        id: this.relation.details.agentId,
        user: {
          firstName: this.relation.details.agentFirstName,
          lastName: this.relation.details.agentLastName
        }
      } : undefined;
    }

  }

  $onChanges(changes) {
    if (changes.relation && !changes.relation.isFirstChange()) {
      this.$onInit();
    }
  };

}

angular
  .module('bringoz.admin.deliveries')
  .component('serviceRelationTaskItem', {
    bindings: {
      index: '<?',
      relation: '<',
      canRemove: '<',
      canUnlink: '<',
      activateActionsOnHover: '<?',
      taskRelatingToType: '<?',
      onUnlinkRelatedTask: '&',
      onRemove: '&'
    },
    template: require('./service-relation-task-item.html').default,
    controller: ServiceRelationTaskItemCtrl
  });
